import axios from 'axios'

const PostingService = {
  async get (params = {}) {
    return axios.get('prd/inter-warehouse-transfer/postings', { params })
  },

  async histories (params = {}) {
    return axios.get('prd/reports/inter-warehouse-transfer/posting-histories', { params })
  },

  async show (id) {
    return axios.get(`prd/inter-warehouse-transfer/postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('prd/inter-warehouse-transfer/postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`prd/inter-warehouse-transfer/postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`prd/inter-warehouse-transfer/postings/${data.id}`, { data })
  }
}

export default PostingService
